import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { message, Spin } from "antd";
import React, { Suspense, useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import commonObj from "./commonObj";
import { useValidateTokenMutation } from "./query/admin.query";
import Loader from "./views/components/Loaders/loader";
import SiteLoader from "./views/components/Loaders/SiteLoader";
import Login from "./views/pages/Login";
Spin.setDefaultIndicator(
	<div>
		<Loader />
	</div>,
);
const LayoutAdmin = React.lazy(() => import("./views/layout/Layout"));

function App() {
	const [isLoggedin, setIsLoggedin] = useState(false);
	const validateTokenMutation = useValidateTokenMutation();
	useEffect(() => {
		validateTokenMutation.mutate(
			null,
			{
				onSuccess: (res) => {
					setIsLoggedin(true);
					commonObj.userType = res.data.type;
					commonObj.adminRights = res.data.modules || [];
					commonObj.name = res.data.name;
					commonObj.avatar = res.data.avatar;
					commonObj.shiprocket = res.data.shiprocket;
					message.success(res.message);
				},
				onError: (err) => {
					setIsLoggedin(false);
					window.localStorage.clear();
					message.error("Unauthorized. Login Again!!");
				}
			}
		)
	}, []);

	return (
		<>
			<BrowserRouter basename="/">
				{!validateTokenMutation.isPending ? (
					isLoggedin ? (
						<Suspense fallback={<SiteLoader />}>
							<LayoutAdmin />
						</Suspense>
					) : (
						<Suspense fallback={<SiteLoader />}>
							<Login />
						</Suspense>
					)
				) : (
					<SiteLoader />
				)}
				<ReactQueryDevtools />
			</BrowserRouter>
		</>
	);
}

export default App;
